export default __webpack_public_path__ + "static/media/secondary_lock-key-alt_icon.9846ef13.svg";